// extracted by mini-css-extract-plugin
module.exports = {"input-wrapper":"style_input-wrapper__xgqoG","icon":"style_icon__7Eg7R"};